import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./css/imageCarousel.css";

const ImageCarousel = ({ images, interval = 3000 }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]); // 👈 CLAVE

  return (
    <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start px-3 px-md-4">
      <div className="carousel-wrapper">
        <img
          src={images[index]}
          alt=""
          className="carousel-img"
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>
    </div>
  );
};

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  interval: PropTypes.number,
};

export default ImageCarousel;
